// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"43":"framer-motion","223":"commons"}[chunkId] || chunkId) + "." + {"43":"2219ca0f","108":"dab780c1","187":"0c5c12a1","223":"b5946d70","629":"aa610a5e","690":"a9a0039a","875":"6dbc838a","965":"cc5d4d49"}[chunkId] + ".chunk.js";
};